import React from 'react';
import Skeleton from './Skeleton';

/**
 * ResidenceWizardSkeleton
 * Shimmer placeholder for the Convert / Edit Residence wizard (ConvertClient):
 *   - title + subtitle on the left, action buttons on the right
 *   - the 6-step stepper with its connecting lines
 *   - the form card with a section heading and a two-column field grid
 * Mirrors the real layout so the page doesn't jump when the data lands.
 */

const S = Skeleton;

const FieldSkeleton = () => (
  <div>
    <S className="h-3 w-28 rounded-md mb-2" />
    <S className="h-11 w-full rounded-lg" />
  </div>
);

const ResidenceWizardSkeleton = () => (
  <div className="w-full py-4">
    {/* Header: title / subtitle + action buttons */}
    <div className="mb-8 flex items-center justify-between gap-4">
      <div className="flex-1 space-y-2">
        <S className="h-7 w-64 max-w-full rounded-xl" />
        <S className="h-3.5 w-72 max-w-full rounded-md" />
      </div>
      <div className="hidden sm:flex items-center gap-3 shrink-0">
        <S className="h-10 w-20 rounded-lg" />
        <S className="h-10 w-20 rounded-lg" />
      </div>
    </div>

    {/* Stepper — 6 steps with connecting lines between them */}
    <div className="flex items-center justify-between overflow-hidden pb-4 mb-6">
      {Array.from({ length: 6 }).map((_, i) => (
        <React.Fragment key={i}>
          <div className="flex items-center gap-2 flex-shrink-0">
            <S className="w-5 h-5 rounded-md" />
            <S className="h-3.5 w-20 rounded-md hidden md:block" />
          </div>
          {i < 5 && <S className="flex-1 min-w-[24px] mx-4 h-0.5 rounded-full" />}
        </React.Fragment>
      ))}
    </div>

    {/* Form card */}
    <div className="bg-white dark:bg-[#262b33] rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 p-8">
      <S className="h-6 w-44 rounded-lg mb-8" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <FieldSkeleton key={i} />
        ))}
      </div>
      <div className="mt-6">
        <S className="h-3 w-28 rounded-md mb-2" />
        <S className="h-24 w-full rounded-lg" />
      </div>
    </div>
  </div>
);

export default ResidenceWizardSkeleton;
